import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { TopicThread } from 'models/topicThread';
import './doneCover.html';
import CommentToDoManager from './managers/todo';

export interface CommentDoneCoverVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
    todoMode: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class CommentDoneCoverVM {
    labels = labels
    icon = 'fas fa-check'

    constructor(
        @inject(wccModules.componentConfig) config: CommentDoneCoverVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const comment = ko.flattenComputed(config.comment);
        const todoMode = ko.flattenComputed(config.todoMode, false);

        const todoManager = new CommentToDoManager(comment, storage);
        const isInToDoList = todoManager.isInToDoList;

        const isVisible = ko.pureComputed(() => todoMode() && !isInToDoList());

        ko.applyBindingsToNode(info.element, {
            'visible': isVisible,

            'css': {
                'wcc-dark-cover': true
            }
        }, this);
    }
}